{
  "INBOX_MGMT": {
    "HEADER": "Innbokser",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Koble til på nytt",
      "FACEBOOK": "Tilkoblingen til Facebook har utløpt eller blitt tilbakekalt. Meldinger til siden kommer ikke frem til denne innboksen, og svar kan mislykkes. En person som administrerer Facebook-siden, må klikke på Koble til på nytt og logge inn på Facebook.",
      "INSTAGRAM": "Tilkoblingen til Instagram har utløpt eller blitt tilbakekalt. Meldinger til kontoen kommer ikke frem til denne innboksen, og svar kan mislykkes. Klikk på Koble til på nytt, og logg inn på den samme Instagram-kontoen. En annen konto oppretter en ny innboks.",
      "GOOGLE": "Tilkoblingen til Google har utløpt eller blitt tilbakekalt. Nye e-poster kommer ikke frem til denne innboksen, og svar kan mislykkes. Klikk på Koble til på nytt, og logg inn på Google som {email}.",
      "MICROSOFT": "Tilkoblingen til Microsoft har utløpt eller blitt tilbakekalt. Nye e-poster kommer ikke frem til denne innboksen, og svar kan mislykkes. Klikk på Koble til på nytt, og logg inn på Microsoft som {email}.",
      "ALLEGRO": "Tilkoblingen til Allegro har utløpt eller blitt tilbakekalt. Meldinger fra kjøpere kommer ikke frem til denne innboksen, og svar kan mislykkes. Klikk på Koble til på nytt, og logg inn på Allegro som selgeren {seller}. En annen selgerkonto oppretter en ny innboks.",
      "IMAP_LOGIN": "E-postserveren avviser IMAP-påloggingen {login}. Nye e-poster kommer ikke frem til denne innboksen. Kontroller IMAP-påloggingen og passordet på fanen {tab}, og lagre dem. Vi fortsetter å prøve å logge inn, og innboksen er i gang igjen så snart påloggingen fungerer.",
      "WHATSAPP": "Tilkoblingen til WhatsApp er utløpt eller trukket tilbake. Vedlegg fra kunder kommer ikke frem til denne innboksen, og svar kan mislykkes. Klikk på Koble til på nytt, logg inn på Facebook og velg nummeret {phone} igjen."
    },
    "LIST": {
      "404": "Det er ingen innbokser tilknyttet denne kontoen.",
      "RECONNECT_REQUIRED": "Må kobles til på nytt"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Velg kanal",
        "BODY": "Velg tilbyderen du vil integrere med chatten."
      },
      "INBOX": {
        "TITLE": "Opprett innboks",
        "BODY": "Autoriser din konto og opprett en innboks."
      },
      "AGENT": {
        "TITLE": "Legg til agenter",
        "BODY": "Legg agenter til i den opprettede innboksen."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Klar - ferdig - gå!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Navn på innboks",
        "PLACEHOLDER": "Enter your inbox name (eg: Acme Inc)",
        "ERROR": "Please enter a valid inbox name"
      },
      "WEBSITE_NAME": {
        "LABEL": "Nettstedsnavn",
        "PLACEHOLDER": "Angi navnet på nettsiden (f. eks.: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Internt navn",
        "PLACEHOLDER": "Navngi innboksen slik den vises i dette dashbordet",
        "ERROR": "Skriv inn et unikt internt navn"
      },
      "FB": {
        "HELP": "PS: Ved å logge inn får vi bare tilgang til meldingene til siden. Dine private meldinger vil aldri bli lest av oss.",
        "CHOOSE_PAGE": "Velg side",
        "CHOOSE_PLACEHOLDER": "Velg en side fra listen",
        "INBOX_NAME": "Navn på innboks",
        "ADD_NAME": "Legge til et navn på innboksen din",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Velg en verdi",
        "CREATE_INBOX": "Opprett innboks"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Fortsett med Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Koble til Instagram-profilen din",
        "HELP": "For å legge til Instagram-profilen din som en kanal, må du autentisere Instagram-profilen din ved å klikke på 'Fortsett med Instagram' ",
        "ERROR_MESSAGE": "Det oppstod en feil ved tilkobling til Instagram, prøv igjen",
        "ERROR_AUTH": "Det oppstod en feil ved tilkobling til Instagram, prøv igjen",
        "NEW_INBOX_SUGGESTION": "Denne Instagram-kontoen var tidligere koblet til en annen innboks og er nå migrert hit. Alle nye meldinger vises her fra nå av. Den gamle innboksen kan ikke lenger sende eller motta meldinger for denne kontoen.",
        "DUPLICATE_INBOX_BANNER": "Denne Instagram-kontoen er migrert til den nye innboksen for Instagram-kanalen. Du kan ikke lenger sende eller motta Instagram-meldinger fra denne innboksen."
      },
      "TWITTER": {
        "HELP": "For å legge til din Twitter-profil som kanal, må du autorisere din Twitter-profil ved å klikke på 'Logg inn med Twitter' ",
        "ERROR_MESSAGE": "There was an error connecting to Twitter, please try again",
        "TWEETS": {
          "ENABLE": "Create conversations from mentioned Tweets"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Nettsidekanal",
        "DESC": "Opprett en kanal for nettstedet ditt og begynn å hjelpe kundene dine via nettstedswidgeten.",
        "LOADING_MESSAGE": "Oppretter nettstedskanal",
        "CHANNEL_AVATAR": {
          "LABEL": "Kanal profilbilde"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Vennligst skriv inn en gyldig URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Nettstedets domene",
          "PLACEHOLDER": "Angi URL på nettsiden (f. eks.: acme.no)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Velkomsttittel",
          "PLACEHOLDER": "Tjohei!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Velkomsthilsen undertittel",
          "PLACEHOLDER": "Det skal være lett å kontakte oss. Spør oss om hva som helst, eller del din tilbakemelding."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Kanalhilsen",
          "PLACEHOLDER": "Acme AS pleier vanligvis å svare i løpet av noen timer."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Aktiver kanalhilsen",
          "HELP_TEXT": "Automatically send a greeting message when a new conversation is created.",
          "ENABLED": "Aktivert",
          "DISABLED": "Deaktivert"
        },
        "REPLY_TIME": {
          "TITLE": "Angi svartid",
          "IN_A_FEW_MINUTES": "Om noen få minutter",
          "IN_A_FEW_HOURS": "Om noen få timer",
          "IN_A_DAY": "Om en dag",
          "HELP_TEXT": "Denne svartiden vil bli vist i live chat widgeten"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widget farge",
          "PLACEHOLDER": "Oppdater fargen brukt i widgeten"
        },
        "SUBMIT_BUTTON": "Opprett innboks",
        "API": {
          "ERROR_MESSAGE": "We were not able to create a website channel, please try again"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Channel",
        "DESC": "Integrate Twilio and start supporting your customers via SMS or WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Konto-SID",
          "PLACEHOLDER": "Skriv inn din Twilio konto-SID",
          "ERROR": "Dette feltet er obligatorisk"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Dette feltet er obligatorisk"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Dette feltet er obligatorisk"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging Service SID",
          "PLACEHOLDER": "Please enter your Twilio Messaging Service SID",
          "ERROR": "Dette feltet er obligatorisk",
          "USE_MESSAGING_SERVICE": "Use a Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Kanaltype",
          "ERROR": "Velg din kanaltype"
        },
        "AUTH_TOKEN": {
          "LABEL": "Autoriseringstoken",
          "PLACEHOLDER": "Vennligst skriv inn din Twilio autoriseringstoken",
          "ERROR": "Dette feltet er obligatorisk"
        },
        "CHANNEL_NAME": {
          "LABEL": "Navn på innboks",
          "PLACEHOLDER": "Please enter a inbox name",
          "ERROR": "Dette feltet er obligatorisk"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonnummer",
          "PLACEHOLDER": "Vennligst angi telefonnummeret som meldinger skal sendes fra.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Du må konfigurere callback URL for meldinger med URLen nevnt her."
        },
        "SUBMIT_BUTTON": "Opprett Twilio-kanal",
        "API": {
          "ERROR_MESSAGE": "Vi kunne ikke godkjenne Twilio legitimasjonsopplysningene, vennligst prøv igjen"
        }
      },
      "SMS": {
        "TITLE": "SMS Channel",
        "DESC": "Start supporting your customers via SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the SMS channel"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Account ID",
            "PLACEHOLDER": "Please enter your Bandwidth Account ID",
            "ERROR": "Dette feltet er obligatorisk"
          },
          "API_KEY": {
            "LABEL": "API Key",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Dette feltet er obligatorisk"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Dette feltet er obligatorisk"
          },
          "APPLICATION_ID": {
            "LABEL": "Application ID",
            "PLACEHOLDER": "Please enter your Bandwidth Application ID",
            "ERROR": "Dette feltet er obligatorisk"
          },
          "INBOX_NAME": {
            "LABEL": "Navn på innboks",
            "PLACEHOLDER": "Please enter a inbox name",
            "ERROR": "Dette feltet er obligatorisk"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonnummer",
            "PLACEHOLDER": "Vennligst angi telefonnummeret som meldinger skal sendes fra.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
          },
          "SUBMIT_BUTTON": "Create Bandwidth Channel",
          "API": {
            "ERROR_MESSAGE": "We were not able to authenticate Bandwidth credentials, please try again"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "You have to configure the message callback URL in Bandwidth with the URL mentioned here."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Innboksnavn",
            "PLACEHOLDER": "Skriv inn et innboksnavn",
            "ERROR": "Dette feltet er obligatorisk"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonnummer",
            "PLACEHOLDER": "Skriv inn telefonnummeret meldinger skal sendes fra.",
            "ERROR": "Oppgi et gyldig telefonnummer som starter med et `+`-tegn."
          },
          "SUBMIT_BUTTON": "Opprett SMS Brana-kanal",
          "API": {
            "ERROR_MESSAGE": "Vi kunne ikke opprette SMS Brana-kanalen"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Innboksnavn",
            "PLACEHOLDER": "Skriv inn et innboksnavn",
            "ERROR": "Dette feltet er obligatorisk"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonnummer",
            "PLACEHOLDER": "Skriv inn telefonnummeret meldinger skal sendes fra.",
            "ERROR": "Oppgi et gyldig telefonnummer som starter med et `+`-tegn."
          },
          "SUBMIT_BUTTON": "Opprett DIDWW-kanal",
          "API": {
            "ERROR_MESSAGE": "Vi kunne ikke opprette DIDWW-kanalen"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "You have to configure the webhook URL and the verification token in the Facebook Developer portal with the values shown below.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Raskt oppsett med Meta",
          "DESC": "Du blir videresendt til Meta for å logge inn på WhatsApp Business-kontoen din. Administratortilgang gjør oppsettet enklere og raskere.",
          "BENEFITS": {
            "EASY_SETUP": "Ingen manuell konfigurasjon nødvendig",
            "SECURE_AUTH": "Sikker autentisering basert på OAuth",
            "AUTO_CONFIG": "Automatisk konfigurasjon av webhook og telefonnummer"
          },
          "SUBMIT_BUTTON": "Koble til med WhatsApp Business",
          "AUTH_PROCESSING": "Autentiserer med Meta",
          "WAITING_FOR_BUSINESS_INFO": "Fullfør bedriftsoppsettet i Meta-vinduet...",
          "PROCESSING": "Setter opp WhatsApp Business-kontoen din",
          "CANCELLED": "Registrering hos WhatsApp ble avbrutt",
          "WAITING_FOR_AUTH": "Venter på autentisering...",
          "INVALID_BUSINESS_DATA": "Ugyldige bedriftsdata mottatt fra Facebook. Prøv igjen.",
          "SIGNUP_ERROR": "Det oppstod en registreringsfeil",
          "SDK_LOAD_ERROR": "Kunne ikke laste inn Facebook SDK. Prøv igjen.",
          "AUTH_NOT_COMPLETED": "Autentisering ikke fullført. Start prosessen på nytt.",
          "SUCCESS_FALLBACK": "WhatsApp Business-kontoen er konfigurert",
          "RECONNECTED": "WhatsApp-kanalen er koblet til på nytt"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the WhatsApp channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API Kanal",
        "DESC": "Integrer med en API-kanal for å støtte dine kunder.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnavn",
          "PLACEHOLDER": "Vennligst skriv inn et kanalnavn",
          "ERROR": "Dette feltet er obligatorisk"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Opprett API-kanal",
        "API": {
          "ERROR_MESSAGE": "Vi klarte ikke å lagre API-kanalen"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce-kanal",
        "DESC": "Integrer med Salesforce-kanalen og begynn å støtte kundene dine.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnavn",
          "PLACEHOLDER": "Skriv inn et kanalnavn",
          "ERROR": "Dette feltet er obligatorisk"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API-URL",
          "SUBTITLE": "Konfigurer grunn-URL-en for Salesforce-instansen din.",
          "PLACEHOLDER": "URL Salesforce-API"
        },
        "KEY_ID": {
          "LABEL": "Nøkkel-ID",
          "SUBTITLE": "Nøkkel-ID for Salesforce-kanalen din.",
          "PLACEHOLDER": "NØKKEL-ID"
        },
        "SECRET": {
          "LABEL": "Hemmelighet",
          "SUBTITLE": "Hemmelighet for Salesforce-kanalen din.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Opprett Salesforce-kanal",
        "API": {
          "ERROR_MESSAGE": "Vi kunne ikke lagre Salesforce-kanalen"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook-URL",
          "SUBTITLE": "Du må konfigurere webhook-URL-en i Salesforce med URL-en som er nevnt her."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer-token",
          "SUBTITLE": "Bruk dette bearer-tokenet for autentisering når du konfigurerer webhooken i Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Overstyr e-postavsender",
          "SUBTITLE": "Hvis angitt, brukes denne e-postadressen som avsender for alle utgående e-poster i stedet for samtalens opprinnelige e-postadresse.",
          "PLACEHOLDER": "f.eks. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro-kanal",
        "DESC": "Koble til en Allegro-selgerkonto og svar på meldingssenteret fra kontaktsenteret.",
        "CHANNEL_NAME": {
          "LABEL": "Innboksnavn",
          "SUBTITLE": "Navnet agenter ser for denne innboksen.",
          "PLACEHOLDER": "Skriv inn et innboksnavn",
          "ERROR": "Dette feltet er obligatorisk"
        },
        "SUBMIT_BUTTON": "Logg inn med Allegro",
        "API": {
          "ERROR_MESSAGE": "Det oppsto en feil ved tilkobling til Allegro, vennligst prøv igjen"
        },
        "SELLER_LOGIN": {
          "TITLE": "Allegro-innlogging",
          "SUBTITLE": "Selgerkontoen denne innboksen leser og svarer på meldinger for."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland-kanal",
        "DESC": "Svar på saksmeldingene kjøpere sender deg på Kaufland-markedsplassen.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnavn",
          "PLACEHOLDER": "Vennligst skriv inn et kanalnavn",
          "ERROR": "Dette feltet er obligatorisk"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Den 32 tegn lange Client Key fra API-innstillingssiden til Kaufland-selgerkontoen din.",
          "PLACEHOLDER": "32 tegn lang nøkkel",
          "ERROR": "Skriv inn den 32 tegn lange Client Key"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Den 64 tegn lange Secret Key som hører til Client Key. Kaufland viser den én gang, og den sendes aldri tilbake til denne siden.",
          "PLACEHOLDER": "64 tegn lang nøkkel",
          "ERROR": "Skriv inn den 64 tegn lange Secret Key"
        },
        "SUBMIT_BUTTON": "Opprett Kaufland-kanal",
        "API": {
          "ERROR_MESSAGE": "Vi kunne ikke lagre Kaufland-kanalen"
        },
        "DISCONNECTED": {
          "TITLE": "Frakoblet",
          "MESSAGE": "Kaufland avviste disse API-nøklene. Skriv inn Client Key og Secret Key på nytt for å koble til denne innboksen igjen."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "E-postkanal",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnavn",
          "PLACEHOLDER": "Vennligst skriv inn et kanalnavn",
          "ERROR": "Dette feltet er obligatorisk"
        },
        "EMAIL": {
          "LABEL": "E-post",
          "SUBTITLE": "E-post der kundene dine sender deg henvendelser",
          "PLACEHOLDER": "E-post"
        },
        "SUBMIT_BUTTON": "Opprett e-postkanal",
        "API": {
          "ERROR_MESSAGE": "Vi kunne ikke lagre e-postkanalen"
        },
        "FINISH_MESSAGE": "Begynn å videresende e-post til følgende e-postadresse."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Channel",
        "DESC": "Integrate with LINE channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnavn",
          "PLACEHOLDER": "Vennligst skriv inn et kanalnavn",
          "ERROR": "Dette feltet er obligatorisk"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Channel ID",
          "PLACEHOLDER": "LINE Channel ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Channel Secret",
          "PLACEHOLDER": "LINE Channel Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Channel Token",
          "PLACEHOLDER": "LINE Channel Token"
        },
        "SUBMIT_BUTTON": "Create LINE Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the LINE channel"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the webhook URL in LINE application with the URL mentioned here."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Channel",
        "DESC": "Integrate with Telegram channel and start supporting your customers.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Configure the bot token you have obtained from Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Create Telegram Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the telegram channel"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Telefonsamtaler",
        "DESC": "Angi hvilke telefonsamtaler som skal vises under denne innboksen.",
        "NAME": {
          "LABEL": "Innboksnavn",
          "SUBTITLE": "Velg et lett gjenkjennelig navn."
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonnummer",
          "SUBTITLE": "Skriv inn telefonnumre som hører til denne innboksen, du kan legge til flere numre senere.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Opprett innboks for telefonsamtaler",
        "API": {
          "ERROR_MESSAGE": "Vi kunne ikke opprette innboksen"
        }
      },
      "AUTH": {
        "TITLE": "Choose a channel",
        "DESC": "Chatten støtter live-chat-widgeter, Facebook Messenger, WhatsApp, e-post osv. som kanaler. Hvis du vil bygge en egendefinert kanal, kan du opprette den med API-kanalen. For å komme i gang, velg en av kanalene nedenfor."
      },
      "AGENTS": {
        "TITLE": "Agenter",
        "DESC": "Her kan du legge til agenter for å administrere innboksen din. Bare de valgte agentene har tilgang til innboksen din. Agenter som ikke er en del av denne innboksen vil ikke kunne se eller svare på meldinger i denne innboksen når de logger inn. <br> <b>PS:</b> Dersom du som administrator trenger tilgang til alle innbokser, må du legge deg selv til som agent i alle innbokser du lager.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Velg agenter for innboksen"
      },
      "DETAILS": {
        "TITLE": "Innboksdetaljer",
        "DESC": "Fra listen under, velg facebook-siden du vil koble til chatten. Du kan også gi innboksen et egendefinert navn for bedre identifisering."
      },
      "FINISH": {
        "TITLE": "Den satt!",
        "DESC": "Du er ferdig med å integrere din facebook-side med chatten. Neste gang en kunde sender en melding fra siden din vil samtalen vises automatisk i innboksen din.<br>Vi gir deg også et widget skript som du enkelt kan legge til på nettstedet ditt. Når dette er direkte på din nettside kan kunder sende deg meldinger fra nettstedet ditt uten hjelp av eksterne verktøy og samtalen vil vises her, i chatten.<br>Kult, eller hva? Vel, vi prøver :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Autentiserer deg med Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Noe gikk galt, oppdater siden...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Vi kunne ikke opprette innboksen. Prøv igjen.",
      "CREATING_CHANNEL": "Oppretter innboksen din...",
      "TITLE": "Konfigurer innboksdetaljer",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Legg til agenter",
      "ADD_AGENTS": "Legger til agenter i innboksen..."
    },
    "FINISH": {
      "TITLE": "Innboksen din er klar!",
      "MESSAGE": "You can now engage with your customers through your new Channel. Happy supporting",
      "BUTTON_TEXT": "Ta meg dit",
      "MORE_SETTINGS": "More settings",
      "WEBSITE_SUCCESS": "Du har nå fullført opprettingen av nettstedskanalen. Kopier koden nedenfor og lim den inn på nettstedet. Neste gang en kunde bruker live-chatten vil samtalen vises automatisk i innboksen din."
    },
    "REAUTH": "Reautoriser",
    "VIEW": "Vis",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Innboksinnstillinger ble oppdatert",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Autotildeling ble oppdatert",
        "ERROR_MESSAGE": "We couldn't update inbox settings. Please try again later."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Aktivert",
        "DISABLED": "Deaktivert"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Aktivert",
        "DISABLED": "Deaktivert"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Aktivert",
        "DISABLED": "Deaktivert"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "fra",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Aktivert",
        "DISABLED": "Deaktivert"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Aktivert",
        "DISABLED": "Deaktivert"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Ingen"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Aktivert",
        "DISABLED": "Deaktivert"
      },
      "ENABLE_HMAC": {
        "LABEL": "Enable"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Aktivert",
        "DISABLED": "Deaktivert"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Aktivert",
        "DISABLED": "Deaktivert"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Aktiver synkronisering av innkommende e-post"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Aktiver egendefinert e-postdomene (betalt tjeneste)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Aktiver behandling av Facebook-kommentarer"
      },
      "SIGNATURE": {
        "TITLE": "HTML-signatur",
        "SUB_TEXT": "Denne signaturen legges til i bunnteksten på hver melding som sendes fra denne innboksen.",
        "HTML_CONTENT": "HTML-kode",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} erstattes med navnet til agenten.\n{'{{'}email{'}}'} erstattes med e-postadressen til agenten som sendte e-posten.\n{'{{'}position{'}}'} erstattes med stillingen til agenten.\n{'{{'}custom_line{'}}'} erstattes med agentens egendefinerte linje.\n{'{{'}email_signature_picture{'}}'} erstattes med URL-adressen til agentens bilde for e-postsignatur (ikke en img-tag) — bruk den som bildekilde (src i en img-tag).",
        "PREVIEW": "Forhåndsvisning"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Signaturer per land",
        "SUB_TEXT": "Et svar får signaturen til kjøperens land.",
        "HELP": "Et svar signeres etter landet til samtalen: Kaufland-butikken, markedsplassen til Allegro-bestillingen, eller ellers språket kjøperen skriver på. Når landet er ukjent eller ikke har noen signatur her, brukes HTML-signaturen ovenfor. Markedsplasser forbyr lenker til nettstedet ditt og kontaktinformasjon, så hold deg til en hilsen og {'{{'}name{'}}'}.",
        "EMPTY": "Du har ingen landsignaturer ennå, så svar bruker HTML-signaturen ovenfor.",
        "COUNTRY": "Velg et land",
        "ADD": "Legg til landsignatur",
        "REMOVE": "Fjern"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Ringeprefiks for telefonnummer",
        "PLACEHOLDER": "Skriv inn prefiks for riktig samtalerouting (f.eks. *99)",
        "HELP_TEXT": "Dette prefikset legges automatisk foran kontaktenes telefonnumre når du ringer fra denne innboksen."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Tekst på «løses senere»-knappen",
        "PLACEHOLDER": "f.eks. Vi løser dette emnet via e-post. Jeg vil spørre om noe annet nå.",
        "HELP_TEXT": "Tekst på knappen i widgeten som lar den besøkende forlate det gjeldende emnet og spørre om noe annet. Hvis feltet står tomt, brukes standardteksten på den besøkendes språk."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Snooze tapte anrop automatisk i X minutter",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Snooze tapte anrop automatisk i det angitte antallet minutter. La stå tomt eller 0 for å deaktivere."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Løs et tapt anrop etter X mislykkede tilbakeringinger",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Når et tapt anrop er ringt tilbake X ganger uten at kunden svarer, løses det automatisk, og et privat notat legges til. La stå tomt eller 0 for å deaktivere."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Spørsmålsforslag",
        "SUB_TEXT": "Konfigurer forhåndsdefinerte spørsmål som kunder kan bruke for å kommunisere med agentene dine.",
        "QUESTIONS_LABEL": "Spørsmål",
        "ADD_QUESTION": "Legg til spørsmål",
        "REMOVE": "Fjern",
        "QUESTION_TEXT": "Tekst som vises i boblen.",
        "QUESTION_TEXT_PLACEHOLDER": "Obligatorisk",
        "QUESTION_PAYLOAD": "Tekst som sendes når det klikkes.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Valgfritt",
        "NO_BOT_MESSAGE": "Koble til en bot for å generere flere AI-forslag.",
        "BOT_CONNECTED_MESSAGE": "AI-spørsmålsforslag fra boten kan aktiveres i dens",
        "BOT_SETTINGS_LINK": "innstillinger"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternative e-poster",
        "SUB_TEXT": "Flere adresser som denne innboksen skal behandle som sine egne når den mottar videresendt e-post.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Legg til",
        "REMOVE": "Fjern",
        "EMPTY": "Ingen alternative e-poster konfigurert.",
        "HELP_TEXT": "Når en e-post kommer inn med en av disse adressene som mottaker, sendes svar med samme adresse som avsender. Sørg for at den utgående SMTP-serveren din tillater sending fra disse adressene.",
        "SIGNATURE_LABEL": "Signatur",
        "PRIMARY_SIGNATURE": "Primær (standard)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Flere signaturer",
        "SUB_TEXT": "Definer flere signaturer her, og tilordne dem deretter til de alternative e-postadressene nedenfor.",
        "OPTION": "Signatur {number}",
        "ADD": "Legg til signatur",
        "REMOVE": "Fjern",
        "HELP_TEXT": "Når et svar sendes fra en alternativ e-postadresse, brukes signaturen som er tilordnet den, i stedet for innboksens signatur. Alternative e-postadresser som er satt til «Primær (standard)», bruker innboksens signatur."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Slett",
      "AVATAR_DELETE_BUTTON_TEXT": "Delete Avatar",
      "DELETE_REQUESTED_TOOLTIP": "Denne innboksen er markert for sletting",
      "RESTORE_BUTTON_TEXT": "Gjenopprett",
      "CONFIRM": {
        "TITLE": "Bekreft sletting",
        "MESSAGE": "Er du sikker på at du vil slette ",
        "PLACE_HOLDER": "Please type {inboxName} to confirm",
        "YES": "Ja, slett ",
        "NO": "Nei, behold "
      },
      "API": {
        "SUCCESS_MESSAGE": "Innboksen ble slettet",
        "MARKED_FOR_DELETION_MESSAGE": "Innboks markert for sletting",
        "RESTORE_SUCCESS_MESSAGE": "Innboksen er gjenopprettet",
        "ERROR_MESSAGE": "Kan ikke slette innboks. Prøv igjen senere.",
        "RESTORE_ERROR_MESSAGE": "Kunne ikke gjenopprette innboksen. Prøv igjen senere.",
        "AVATAR_SUCCESS_MESSAGE": "Inbox avatar deleted successfully",
        "AVATAR_ERROR_MESSAGE": "Could not delete the inbox avatar. Please try again later."
      }
    },
    "TABS": {
      "SETTINGS": "Innstillinger",
      "COLLABORATORS": "Samarbeidspartnere",
      "AUTOMATIC_PRIORITY": "Automatisk prioritet",
      "AUTOMATIC_LABELING": "Automatisk merking",
      "CONFIGURATION": "Konfigurasjon",
      "CAMPAIGN": "Campaigns",
      "PRE_CHAT_FORM": "Pre Chat Form",
      "BUSINESS_HOURS": "Business Hours",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Bot Configuration",
      "SLA": "SLA"
    },
    "SETTINGS": "Innstillinger",
    "FEATURES": {
      "LABEL": "Funksjoner",
      "DISPLAY_FILE_PICKER": "Vis filvelger i widget",
      "DISPLAY_EMOJI_PICKER": "Vis emoji-velger i widget",
      "ALLOW_END_CONVERSATION": "Allow users to end conversation from the widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Vis knappen 'Start en ny samtale' i widget-headeren",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "SHOW_HANDOFF_BUTTON": "Vis knappen 'Overfør til en operatør' i widget-headeren",
      "AUTO_CLOSE_OLD": "Merk alle tidligere anrop fra samme nummer som løst når ett av dem er løst",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Tildel tapte anrop automatisk når du ringer et utgående anrop",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Tillat agenter å sende meldinger når kontakten er frakoblet og e-postkontinuitet ikke er tilgjengelig"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Kopi av samtale",
      "MESSENGER_SUB_HEAD": "Plasser denne knappen innenfor body-taggen",
      "INBOX_AGENTS": "Agenter",
      "INBOX_TEAMS": "Team",
      "INBOX_COOPERATORS": "Samarbeidspartnere",
      "SELECT_PLACEHOLDER": "Velg",
      "AGENTS_OR_TEAMS_INFO": "Du kan tildele enten agenter eller team - ikke begge samtidig.",
      "INBOX_AGENTS_SUB_TEXT": "Legg til eller fjern agenter fra denne innboksen",
      "AGENT_ASSIGNMENT": "Conversation Assignment",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Update conversation assignment settings",
      "UPDATE": "Oppdater",
      "ENABLE_EMAIL_COLLECT_BOX": "Enable email collect box",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Enable or disable email collect box on new conversation",
      "AUTO_ASSIGNMENT": "Aktiver autotilordning",
      "ENABLE_CSAT": "Enable CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Aktiver CSAT for hver melding",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Enable/Disable CSAT(Customer satisfaction) survey after resolving a conversation",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Aktiver/deaktiver CSAT-undersøkelse for hver melding sendt av agenter",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Enable conversation continuity via email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Conversations will continue over email if the contact email address is available.",
      "RESPOND_FROM_EMAIL": "Svar fra e-postadresse",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "E-poster til kunden — både svar og samtaletranskripsjoner — sendes med SMTP-innstillingene til den valgte e-postinnboksen, fra den valgte adressen (innboksens egen adresse eller et av dens aliaser), og kundens svar kommer tilbake via dens IMAP-adresse.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Samtaletranskripsjoner sendes med SMTP-innstillingene til den valgte e-postinnboksen, fra den valgte adressen (innboksens egen adresse eller et av dens aliaser), og svar kommer tilbake via dens IMAP-adresse.",
      "SHOW_WELCOME_SCREEN": "Vis velkomstskjerm",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Vis velkomstskjermen når widgeten åpnes. Hvis deaktivert, går widgeten direkte til samtalevisningen.",
      "AUTO_CLOSE_PENDING": "Løs AI-chatter automatisk etter (timer)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Løs AI-chatter automatisk etter X timer med inaktivitet.",
      "LOCK_TO_SINGLE_CONVERSATION": "Lock to single conversation",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Enable or disable multiple conversations for the same contact in this inbox",
      "INBOX_UPDATE_TITLE": "Innboksinnstillinger",
      "INBOX_UPDATE_SUB_TEXT": "Oppdater innboksinnstillinger",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Aktiver eller deaktiver automatisk tildeling av nye samtaler til agenter som er lagt til i denne innboksen.",
      "HMAC_VERIFICATION": "Brukeridentitetsvalidering",
      "HMAC_DESCRIPTION": "In order to validate the user's identity, you can pass an `identifier_hash` for each user. You can generate a HMAC sha256 hash using the `identifier` with the key shown here.",
      "HMAC_ROTATE": {
        "BUTTON": "Roter nøkkel",
        "TITLE": "Rotere hemmelig nøkkel?",
        "WARNING": "Den nåværende nøkkelen tilbakekalles i det øyeblikket du roterer den.",
        "WARNING_DETAIL": "Det er ingen overlappingsperiode, og den kan ikke gjenopprettes.",
        "IMPACT": "Serverne dine må signere brukere med den nye nøkkelen. Alle som fortsatt er signert med den gamle, mislykkes i verifiseringen. Hvis identitetsvalidering er påkrevd, kan de ikke starte en samtale.",
        "CONFIRM": "Roter nøkkel",
        "CANCEL": "Avbryt",
        "SUCCESS": "Hemmelig nøkkel rotert",
        "ERROR": "Kunne ikke rotere den hemmelige nøkkelen. Prøv igjen"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Enforce User Identity Validation",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests missing the `identifier_hash` will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Tving ny samtale ved hver innlasting av widgeten",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Hvis aktivert, starter åpning av widgeten i en ny fane eller et nytt vindu en ny samtale.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Glem kontakten når en ny samtale startes",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Hvis deaktivert, beholder en ny samtale startet fra widgeten den forrige kontakten.",
      "INBOX_IDENTIFIER": "Inbox Identifier",
      "INBOX_IDENTIFIER_SUB_TEXT": "Use the `inbox_identifier` token shown here to authentication your API clients.",
      "FORWARD_EMAIL_TITLE": "Forward to Email",
      "FORWARD_EMAIL_SUB_TEXT": "Begynn å videresende e-post til følgende e-postadresse.",
      "EMAIL_FETCHING_ENABLED_TITLE": "E-postsynkronisering",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Aktiver automatisk synkronisering og nedlasting av innkommende e-post fra denne innboksen",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Egendefinert e-postdomene",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Aktiver for å bruke et egendefinert e-postdomene for utgående e-post",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Du kan lese mer her.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook-kommentarer",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Allow messages after conversation resolved",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Allow the end-users to send messages even after the conversation is resolved.",
      "WIDGET_STATUS_LABEL": "Widgetstatus",
      "WIDGET_STATUS_ENABLED": "Aktivert",
      "WIDGET_STATUS_BUSINESS_HOURS": "Aktivert i åpningstiden",
      "WIDGET_STATUS_DISABLED": "Deaktivert",
      "WIDGET_STATUS_HELP_TEXT": "Styr når widgeten vises for besøkende på nettstedet ditt",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "Språk for CSAT-undersøkelse og e-post",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Velg språket for alle kunde-e-poster, inkludert CSAT-undersøkelser, samtaletranskripsjoner og e-postvarsler",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Arv fra konto",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp-tilkobling",
        "SUBTITLE": "Slik er denne innboksen koblet til WhatsApp.",
        "PROVIDER": "Leverandør",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Koblet til via Metas innebygde registrering",
        "STATUS": "Status",
        "CONNECTED": "Tilkoblet",
        "RECONNECT_HINT": "Klikk Koble til på nytt i meldingen ovenfor.",
        "PHONE_NUMBER": "Telefonnummer",
        "BUSINESS_ACCOUNT": "WhatsApp Business-konto-ID",
        "OPEN_MANAGER": "Åpne i WhatsApp Manager",
        "PHONE_NUMBER_ID": "Telefonnummer-ID",
        "TEMPLATES": "Meldingsmaler",
        "TEMPLATES_COUNT": "{approved} av {total} godkjent",
        "TEMPLATES_SYNCED": "Sist synkronisert {date}",
        "TEMPLATES_NOT_SYNCED": "Ikke synkronisert ennå",
        "MANAGE_TEMPLATES": "Administrer maler"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Auto assignment limit",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Please enter a value greater than 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limit the maximum number of conversations from this inbox that can be auto assigned to an agent"
    },
    "SLA": {
      "TITLE": "SLA-retningslinjer",
      "SUB_TEXT": "Konfigurer SLA-responstid og løsningstid for hvert prioritetsnivå for samtaler.",
      "LOADING": "Laster SLA-retningslinjer...",
      "FIELDS": {
        "ACTIVE": "Aktiv",
        "TICKET_PRIORITY": "Sakens prioritet",
        "FIRST_RESPONSE_TIME": "Første responstid",
        "EVERY_RESPONSE_TIME": "Responstid for hvert svar",
        "RESOLUTION_TIME": "Løsningstid",
        "PLACEHOLDER": "f.eks. 1t 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA-retningslinjene er oppdatert.",
        "ERROR_MESSAGE": "Kunne ikke oppdatere SLA-retningslinjene. Prøv igjen."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatisk prioritet",
      "SUB_TEXT": "Konfigurer automatisk tildeling av prioritet basert på samtaleinnholdet.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Faktureringsmerknad",
        "MESSAGE": "Hver prioritetsvurdering medfører en kostnad. Se planinformasjonen din for prisdetaljer."
      },
      "MODE": {
        "OFF": "Av",
        "ALL_MESSAGES": "På for alle innkommende meldinger",
        "FIRST_MESSAGE": "På kun for første innkommende melding"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Konfigurasjon av prioritetsnivåer",
        "SUB_TEXT": "Konfigurer hvilke prioritetsnivåer som skal være aktivert, og beskrivelsene deres. Oppgi tydelige kriterier slik at AI kan avgjøre når denne prioriteten skal tildeles."
      },
      "DESCRIPTION_LABEL": "Beskrivelse",
      "DESCRIPTION_PLACEHOLDER": "Beskriv samtaler som skal merkes med prioritet {priority}",
      "SET_AS_DEFAULT": "Angi som standardprioritet",
      "MULTIPLE_DEFAULTS_WARNING": "Bare ett prioritetsnivå skal angis som standard. Fjern haken for de andre standardvalgene."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatisk merking",
      "SUB_TEXT": "Konfigurer automatisk tildeling av etiketter basert på samtaleinnholdet.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Faktureringsmerknad",
        "MESSAGE": "Hver merkevurdering medfører en kostnad. Se planinformasjonen din for prisdetaljer."
      },
      "MODE": {
        "OFF": "Av",
        "CONVERSATION_OPEN": "Ved åpning av samtale",
        "CONVERSATION_CLOSE": "Ved lukking av samtale",
        "ALL_MESSAGES": "Ved hver melding - uavhengig av status",
        "FIRST_MESSAGE": "Ved første melding - uavhengig av status"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Etikettkonfigurasjon",
        "SUB_TEXT": "Konfigurer hvilke etiketter som skal være tilgjengelige for automatisk tildeling, og beskrivelsene deres. Oppgi tydelige kriterier slik at AI kan avgjøre når denne etiketten skal brukes."
      },
      "DESCRIPTION_LABEL": "Beskrivelse",
      "DESCRIPTION_PLACEHOLDER": "Beskriv samtaler som skal merkes som {label}. Hvis du lar dette stå tomt, brukes etikettens beskrivelse.",
      "NO_LABELS_MESSAGE": "Ingen etiketter funnet. Opprett etiketter først for å aktivere automatisk merking.",
      "CREATE_LABELS_LINK": "Opprett etiketter"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Reautoriser",
      "SUBTITLE": "Facebook-tilkoblingen din er utløpt, koble til Facebook-siden din for å fortsette tjenester",
      "MESSAGE_SUCCESS": "Ny tilkobling vellykket",
      "MESSAGE_ERROR": "Det oppstod en feil. Prøv igjen"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Pre chat forms enable you to capture user information before they start conversation with you.",
      "SET_FIELDS": "Pre chat form fields",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Fields",
        "LABEL": "Label",
        "PLACE_HOLDER": "Placeholder",
        "KEY": "Key",
        "TYPE": "Type",
        "REQUIRED": "Required"
      },
      "ENABLE": {
        "LABEL": "Enable pre chat form",
        "OPTIONS": {
          "ENABLED": "Yes",
          "DISABLED": "No"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre chat message",
        "PLACEHOLDER": "This message would be visible to the users along with the form"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Visitors should provide their name and email address before starting the chat"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Set your availability",
      "SUBTITLE": "Set your availability on your livechat widget",
      "WEEKLY_TITLE": "Set your weekly hours",
      "TIMEZONE_LABEL": "Select timezone",
      "UPDATE": "Update business hours settings",
      "TOGGLE_AVAILABILITY": "Enable business availability for this inbox",
      "UNAVAILABLE_MESSAGE_LABEL": "Unavailable message for visitors",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Enable availability for this day",
        "UNAVAILABLE": "Unavailable",
        "HOURS": "hours",
        "VALIDATION_ERROR": "Starting time should be before closing time.",
        "CHOOSE": "Choose"
      },
      "ALL_DAY": "All-Day",
      "SAVE_TO_ALL": "Lagre til alle innbokser",
      "SAVE_TO_ALL_TITLE": "Kopier arbeidstider",
      "SAVE_TO_ALL_CONFIRM": "Innstillingene fra dette skjemaet (tilgjengelighetsbryter, fraværsmelding, tidssone og arbeidstider) kopieres til alle andre innbokser unntatt e-post- og telefoninnbokser. Er du sikker på at du vil fortsette?",
      "SAVE_TO_ALL_CANCEL": "Avbryt",
      "SAVE_TO_ALL_YES": "Ja, kopier til alle",
      "SAVE_TO_ALL_SUCCESS": "Arbeidstidene er kopiert til alle andre innbokser",
      "SAVE_TO_ALL_ERROR": "Kunne ikke kopiere arbeidstider til andre innbokser"
    },
    "PHONE": {
      "TITLE": "Telefoninnstillinger",
      "SUBTITLE": "Konfigurer hvilke anrop som skal vises under denne innboksen.",
      "UPDATE": "Lagre innstillinger",
      "EDIT": {
        "SUCCESS_MESSAGE": "Telefoninnstillingene er oppdatert"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Telefonnumre",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Set your IMAP details",
      "NOTE_TEXT": "To enable SMTP, please configure IMAP.",
      "UPDATE": "Update IMAP settings",
      "TOGGLE_AVAILABILITY": "Enable IMAP configuration for this inbox",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update IMAP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Logg inn",
        "PLACE_HOLDER": "Logg inn"
      },
      "PASSWORD": {
        "LABEL": "Passord",
        "PLACE_HOLDER": "Passord"
      },
      "ENABLE_SSL": "Enable SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Set your SMTP details",
      "UPDATE": "Update SMTP settings",
      "TOGGLE_AVAILABILITY": "Enable SMTP configuration for this inbox",
      "TOGGLE_HELP": "Enabling SMTP will help the user to send email",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update SMTP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Logg inn",
        "PLACE_HOLDER": "Logg inn"
      },
      "PASSWORD": {
        "LABEL": "Passord",
        "PLACE_HOLDER": "Passord"
      },
      "DOMAIN": {
        "LABEL": "Domain",
        "PLACE_HOLDER": "Domain"
      },
      "ENCRYPTION": "Encryption",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Verify Mode",
      "AUTH_MECHANISM": "Authentication"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Leveringsevne for e-post (DNS)",
      "SUB_TITLE": "Vi kontrollerer SPF-, DKIM-, DMARC- og MX-oppføringene for {domain} hver arbeidsdag. Når noe gjør at mottakerservere avviser svarene dine eller flytter dem til søppelpost, får administratorene en e-post med løsningen.",
      "RUN": "Kjør kontroll",
      "RUN_SUCCESS": "DNS-kontrollen er fullført",
      "RUN_ERROR": "Kunne ikke kjøre DNS-kontrollen. Prøv igjen.",
      "NOT_CHECKED": "Ikke kontrollert ennå.",
      "CHECKED_AT": "Sist kontrollert {time}.",
      "DNS_UNAVAILABLE": "Den siste kontrollen fikk ikke svar fra navneserverne til domenet. Resultatet nedenfor er fra forrige kontroll.",
      "SENDER": {
        "SMTP": "Svar sendes via {host}.",
        "PLATFORM": "Svar sendes via våre e-postservere."
      },
      "STATUS": {
        "OK": "Alle oppføringer er i orden",
        "WARNING": "Noen oppføringer kan forbedres",
        "ERROR": "Svar kommer kanskje ikke frem til mottakerne",
        "UNKNOWN": "Ukjent"
      },
      "SEVERITY": {
        "ERROR": "Problem",
        "WARNING": "Advarsel"
      },
      "FIX": "Rett det opp med denne DNS-oppføringen:",
      "RECORD_TYPE": "Type",
      "RECORD_HOST": "Navn",
      "RECORD_VALUE": "Verdi",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "SPF-oppføring mangler",
          "DESCRIPTION": "Domenet oppgir ikke hvilke servere som kan sende e-post for det. Mange e-postservere behandler da svarene dine som søppelpost. Legg til en SPF-oppføring som tillater {sender}."
        },
        "spf_multiple": {
          "TITLE": "Domenet har {count} SPF-oppføringer",
          "DESCRIPTION": "Et domene kan bare ha én SPF-oppføring. Hvis det er flere, ignorerer mottakerserverne SPF og avviser ofte e-posten. Slå dem sammen til én oppføring."
        },
        "spf_not_authorized": {
          "TITLE": "SPF tillater ikke serveren som sender svarene dine",
          "DESCRIPTION": "Svarene dine sendes via {sender}, men SPF-oppføringen til domenet nevner den ikke. Gjeldende oppføring: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF-oppføringen krever for mange DNS-oppslag",
          "DESCRIPTION": "Mottakerservere slutter å kontrollere SPF etter {limit} DNS-oppslag, men {sender}, som sender svarene dine, nås først etter {lookups}. Svarene dine feiler på SPF. Flytt {sender} til starten av oppføringen og fjern include-oppføringer som domenet ikke lenger bruker."
        },
        "spf_lookups_others": {
          "TITLE": "Noen avsendere i SPF-oppføringen ligger utenfor oppslagsgrensen",
          "DESCRIPTION": "SPF-oppføringen krever {lookups} DNS-oppslag, mens mottakerservere stopper etter {limit}. Svarene dine blir gjenkjent i tide og består, men e-post fra disse avsenderne feiler på SPF: {senders}. Fjern include-oppføringer som domenet ikke lenger bruker."
        },
        "spf_malformed": {
          "TITLE": "SPF-oppføringen er ødelagt",
          "DESCRIPTION": "Mottakerservere kan ikke lese SPF-oppføringen til domenet, så den beskytter ikke svarene dine. Feilen ligger i: {terms}. Bytt ut oppføringen med den rettede."
        },
        "dkim_missing": {
          "TITLE": "DKIM-signatur er ikke satt opp",
          "DESCRIPTION": "Vi fant ingen DKIM-nøkkel på {selectors}. Uten den blir ikke svarene dine signert, og de havner oftere i søppelpost. Slå på DKIM-signering for domenet hos e-postleverandøren din."
        },
        "dmarc_missing": {
          "TITLE": "DMARC-oppføring mangler",
          "DESCRIPTION": "Store e-postleverandører som Gmail og Microsoft forventer en DMARC-oppføring. Uten den havner svarene dine oftere i søppelpost."
        },
        "dmarc_fails": {
          "TITLE": "DMARC ber mottakerne avvise svarene dine",
          "DESCRIPTION": "DMARC-policyen til domenet er «{policy}», og svarene dine består verken SPF eller DKIM. Derfor avviser mottakerne dem eller flytter dem til søppelpost. Rett opp SPF og DKIM ovenfor."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blokkerer svar som sendes via våre e-postservere",
          "DESCRIPTION": "Denne innboksen sender svar via våre e-postservere, men DMARC-policyen til domenet er «{policy}». Derfor avviser mottakerne dem eller flytter dem til søppelpost. Sett opp SMTP for din egen e-postserver for denne innboksen."
        },
        "mx_missing": {
          "TITLE": "Domenet har ingen MX-oppføring",
          "DESCRIPTION": "Uten en MX-oppføring kan ingen sende e-post til domenet, så kundene kan ikke svare på meldingene dine."
        }
      }
    },
    "NOTE": "Note: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar deleted successfully",
              "ERROR_MESSAGE": "Det oppstod en feil. Prøv igjen"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Nettstedsnavn",
          "PLACE_HOLDER": "Angi navnet på nettsiden (f. eks.: Acme Inc)",
          "ERROR": "Please enter a valid website name"
        },
        "WELCOME_HEADING": {
          "LABEL": "Velkomsttittel",
          "PLACE_HOLDER": "Hi there!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Velkomsthilsen undertittel",
          "PLACE_HOLDER": "Det skal være lett å kontakte oss. Spør oss om hva som helst, eller del din tilbakemelding."
        },
        "REPLY_TIME": {
          "LABEL": "Reply Time",
          "IN_A_FEW_MINUTES": "Om noen få minutter",
          "IN_A_FEW_HOURS": "Om noen få timer",
          "IN_A_DAY": "Om en dag"
        },
        "WIDGET_COLOR_LABEL": "Widget farge",
        "WIDGET_BUBBLE_POSITION_LABEL": "Widget Bubble Position",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Maks høyde for uleste meldinger (px)",
          "PLACE_HOLDER": "Ingen grense",
          "HELP_TEXT": "Begrens den maksimale høyden på popup-vinduet for uleste meldinger i piksler. La feltet stå tomt for standardatferd (ingen grense)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget Bubble Type",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Chat med oss",
          "LABEL": "Widget Bubble Launcher Title",
          "PLACE_HOLDER": "Chat med oss"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Update Widget Settings",
          "API": {
            "SUCCESS_MESSAGE": "Widget settings updated successfully",
            "ERROR_MESSAGE": "Unable to update widget settings"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Preview",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Left",
          "RIGHT": "Right"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Expanded Bubble"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Default",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Svarer vanligvis innen et par timer",
        "IN_A_FEW_HOURS": "Svarer vanligvis innen et par timer",
        "IN_A_DAY": "Svarer vanligvis innen en dag"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Start samtale",
        "CHAT_INPUT_PLACEHOLDER": "Skriv inn meldingen"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "We are Online",
          "OFFLINE": "Vi er for øyeblikket borte"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hello"
      },
      "BRANDING_TEXT": "Drevet av JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Nettsted",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "E-post",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API Kanal",
      "PHONE": "SIP-telefon",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
